module.exports = __webpack_public_path__ + "icon_palveluvayla.63995ce0e97f10cdccdf.svg";